import { AccountService } from 'app/store/services/account.service';
import { Component, Inject, OnInit } from '@angular/core';
import { IAccount } from 'app/store/models/account.model';
import { Store } from '@ngrx/store';
import { IReducers } from 'app/store/reducers';
import { openDialog, openSnackbar } from 'app/store/actions/page.action';
import { AccountsUnderComponent } from '../accounts-under/accounts-under.component';
import { IVsmGroup } from '../../../store/models/vsm.model';
import { TABLE_COMPONENT, TableComponent } from '../../../shared/ui/table/table.component';

@Component({
  selector: 'app-vsm-control',
  templateUrl: './vsm-control.component.html',
  styleUrls: ['./vsm-control.component.scss'],
})
export class VsmControlComponent implements OnInit {
  public column: IAccount;
  public vsms: IVsmGroup[];

  constructor(
    private store: Store<IReducers>,
    private accountService: AccountService,
    @Inject(TABLE_COMPONENT) private tableComponent: TableComponent,
  ) {
  }

  getVsms() {
    return this.vsms.map(manager => {
      return {
        label: manager.name,
        value: manager.id,
      };
    });
  }

  onVsmSelect(vsmId) {
    if (!vsmId) {
      return;
    }
    this.accountService.setAccountVsm(this.column.account_id, vsmId).subscribe(
      () => {
        this.store.dispatch(
          openSnackbar({
            snackbarData: {
              data: {
                message: `Edge has been successfully updated for ${this.column.first_name} ${this.column.last_name}`,
                type: 'success',
              },
            },
          }),
        );
        this.tableComponent.refresh();
      },
      error =>
        this.store.dispatch(
          openSnackbar({
            snackbarData: {
              data: {
                message: error.error,
                type: 'error',
              },
            },
          }),
        ),
    );
  }

  ngOnInit() {
  }

  openDialog() {
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: `User Account(s) under ${this.column.first_name} ${this.column.last_name}`,
          content: AccountsUnderComponent,
          componentData: {
            items: this.column.visible_users,
          },
          dialogMinWidth: '1000px',
          canClose: true,
        },
      }),
    );
  }

  resetVsm() {
    this.accountService.setAccountVsm(this.column.account_id, null).subscribe(
      () => {
        this.store.dispatch(
          openSnackbar({
            snackbarData: {
              data: {
                message: `Edge has been successfully updated for ${this.column.first_name} ${this.column.last_name}`,
                type: 'success',
              },
            },
          }),
        );

        this.tableComponent.refresh();
      },
      error =>
        this.store.dispatch(
          openSnackbar({
            snackbarData: {
              data: {
                message: error.error,
                type: 'error',
              },
            },
          }),
        ),
    );
  }
}
